import { WEB_COMPONENT_EXCHANGE_PROTECTION_DETAILS_PANEL } from '../../webcomponents.constants';
import { ExchangeProtectionDetailsPanelWebComponent } from './component/ExchangeProtectionDetailsPanelWebComponent';
export { ExchangeProtectionDetailsPanelWebComponent };

window.customElements.define(
  WEB_COMPONENT_EXCHANGE_PROTECTION_DETAILS_PANEL,
  ExchangeProtectionDetailsPanelWebComponent
);
